import { createContext, useContext } from 'react';
import type { DataConnection, NodeInstance } from '@glueapp/graph-types';

/**
 * Merges the provided nodes and connections into the current graph and returns
 * the real ids that were assigned to the merged nodes, in input order. Callers
 * that don't need the ids can ignore the return value.
 */
export type MergeInGraphFn = (nodes: NodeInstance[], connections: DataConnection[], deselectOld?: boolean) => number[];

export const MergeInGraphContext = createContext<MergeInGraphFn | null>(null);

export const MergeInGraphContextProvider = MergeInGraphContext.Provider;

export function useMergeInGraph() {
    return useContext(MergeInGraphContext);
}
